
module.exports = {
  // TODO: change your profile information here
  name: "Abhay Chauhan",
  greeting: "Hey 👋",
  greetingDescription: "I'm Abhay Chauhan and I'm a Full Stack Web Developer and a Competitive Coder!",
  githubUrl: "https://github.com/abhay27chauhan",
  linkedinUrl: "https://www.linkedin.com/in/imabhay/",
  cvLink: "https://drive.google.com/file/d/1SS-bp_F24QQcETvxn7aB72SIgkmsNfWi/view",
};
